import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import ErrorWrapper from '../../../lib/error_wrapper';
import { Row, Col, List, Typography, Table, Tag, Collapse, Button, Icon, DatePicker, Select } from 'antd';
import moment from 'moment';
import { Link } from 'react-router-dom';
import NetworkSelect from '../../../lib/ui/network_select';
import { overrideHeaderTitle, overrideHeaderBack, defaultDateFormat, formatMoney } from '../../../lib/util';
import FilterFixedInput from '../../../components/filter_fixed_input';
import { BasicHeader } from '../../../components/basic_header';
import { setting_quick_menu } from '../../../util/ui_util';
import CustomDateRangePicker from '../../../components/custom_date_range';
const { Title } = Typography;
const { Panel } = Collapse;

const log_types = ["EXCEPTION", "INFO", "WARNING", "CRITICAL"]
const queryString = require('query-string');

const customPanelStyle = {
  background: '#FFFFFF',
  borderRadius: 6,
  marginBottom: 12,
  border: 0,
  overflow: 'hidden',
};
class UserLogs extends Component {
  constructor(props) {
    super(props)

    this.state = {
      filter_query: {}
    }
    this.list_logs = RESTExecutor.list().config({
      label: 'user_logs',
      params: {
        per_page: 100
      }
    }).connect(props.domains.logs);

  }

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }

  getParams = () => {
    let params = JSON.parse(JSON.stringify(this.state.filter_query));

    return params;
  }



  render() {
    let list_logs_resp = this.list_logs.response();
    let list_logs_data = list_logs_resp.result || {};
    let rowsData = list_logs_data.rows || [];
    let rowsMeta = list_logs_resp.meta || {};
    const { filter_query } = this.state;

    return (
      <div>
        <BasicHeader
          no_back
          title="User Logs"
          menu_items={setting_quick_menu}
        />
        <div className='filter-card'>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            // justifyContent: 'space-between',
            flexWrap: 'wrap',
            paddingTop: 4, paddingBottom: 4
          }}>
            {/* <FilterFixedInput label="Date From">
              <DatePicker
                placeholder="From"
                style={{
                  // width: 300,
                  // margin:4
                }}
                value={filter_query.from ? moment(filter_query.from, "YYYY-MM-DD") : null}
                allowClear
                onChange={(date, dateString) => {
                  this.stateUpdater({
                    stateKey: 'filter_query',
                    valueKey: 'from',
                    value: date ? dateString : null,
                    appendObj: {
                      per_page: 100, page: 1
                    },
                    callback: () => {

                      this.props.history.push({
                        pathname: "users",
                        search: queryString.stringify(this.state.filter_query)
                      })
                    }
                  })
                }}
                format={'YYYY-MM-DD'}
              />
            </FilterFixedInput>
            <FilterFixedInput label="Date To">
              <DatePicker
                placeholder="To"
                style={{
                  // width: 300,
                  // margin:4
                }}
                value={filter_query.to ? moment(filter_query.to, "YYYY-MM-DD") : null}
                allowClear
                onChange={(date, dateString) => {
                  this.stateUpdater({
                    stateKey: 'filter_query',
                    valueKey: 'to',
                    value: date ? dateString : null,
                    appendObj: {
                      per_page: 100, page: 1
                    },
                    callback: () => {

                      this.props.history.push({
                        pathname: "users",
                        search: queryString.stringify(this.state.filter_query)
                      })
                      // this.list_logs.config({
                      //   params: {
                      //     ...this.getParams()
                      //   }
                      // }).execute()
                    }
                  })
                  console.log("DATE", date, dateString);

                }}
                // defaultValue={moment('2015/01/01', 'YYYY/MM/DD')} 
                format={'YYYY-MM-DD'}
              />
            </FilterFixedInput>
           */}
            <FilterFixedInput label="Log Type">
              <Select
                className={filter_query.type != null ? 'filter-option-selected' : ''}
                placeholder="Log Type"
                style={{
                  // width: 300,margin:4
                }}
                value={filter_query.type}
                onChange={(value) => {
                  this.stateUpdater({
                    stateKey: 'filter_query',
                    valueKey: 'type',
                    value: value,
                    appendObj: {
                      per_page: 100, page: 1
                    },
                    callback: () => {

                      this.props.history.push({
                        pathname: "users",
                        search: queryString.stringify(this.state.filter_query)
                      })
                      // this.list_logs.config({
                      //   params: {
                      //     ...this.getParams()
                      //   }
                      // }).execute()
                    }
                  })
                }}
                allowClear
              >
                {log_types.map((item) => {
                  return <Select.Option key={item} value={item}>
                    {item}
                  </Select.Option>
                })}

              </Select>
            </FilterFixedInput>
            <FilterFixedInput label="User">
              <NetworkSelect
                value={filter_query.user_id}
                // style={{margin:4}}
                item={{ name: "User", className: filter_query.user_id != null ? 'filter-option-selected' : '' }}
                url={'/users'}
                onChange={(received_value) => {
                  this.stateUpdater({
                    stateKey: 'filter_query',
                    valueKey: 'user_id',
                    value: received_value,
                    appendObj: {
                      per_page: 100, page: 1
                    },
                    callback: () => {

                      this.props.history.push({
                        pathname: "users",
                        search: queryString.stringify(this.state.filter_query)
                      })
                      // this.list_logs.config({
                      //   params: {
                      //     ...this.getParams()
                      //   }
                      // }).execute()
                    }
                  })
                  // this._change(item.index, received_value, d_key)
                }}
              />
            </FilterFixedInput>
            <FilterFixedInput label="Entity">
              <NetworkSelect
                value={filter_query.entity}
                // style={{margin:4}}
                item={{ name: "Entity", display_key: 'entity', item_key: 'entity', className: filter_query.entity != null ? 'filter-option-selected' : '' }}
                url={'/user-log-entities'}
                onChange={(received_value) => {
                  this.stateUpdater({
                    stateKey: 'filter_query',
                    valueKey: 'entity',
                    value: received_value,
                    appendObj: {
                      per_page: 100, page: 1
                    },
                    callback: () => {

                      this.props.history.push({
                        pathname: "users",
                        search: queryString.stringify(this.state.filter_query)
                      })
                      // this.list_logs.config({
                      //   params: {
                      //     ...this.getParams()
                      //   }
                      // }).execute()
                    }
                  })
                  // this._change(item.index, received_value, d_key)
                }}
              />
            </FilterFixedInput>
            <FilterFixedInput label="Date Range">
                            <CustomDateRangePicker
                                style={{
                                    // width: 400,
                                    // marginLeft: 16,
                                    flex: null
                                }}
                                startDate={filter_query.dateFrom?moment(filter_query.dateFrom, defaultDateFormat):null}
                                endDate={filter_query.dateTo?moment(filter_query.dateTo, defaultDateFormat):null}
                                onChange={(dates) => {
                                    //   console.log("GOT DATES",dates.startDate.toISOString(),dates.endDate.toISOString())
                                    this.stateUpdater({
                                        stateKey: 'filter_query', appendObj: {
                                            dateFrom: dates.startDate.format(defaultDateFormat),
                                            dateTo: dates.endDate.format(defaultDateFormat),
                                            per_page: 100, page: 1
                                        },
                                        callback: () => {
                                            this.props.history.push({
                                                search: queryString.stringify(this.state.filter_query)
                                            })
                                        }
                                    })
                                }}

                            />
                            </FilterFixedInput>

          </div>
        </div>
        <ErrorWrapper
          error={list_logs_resp}
          onReload={() => {
            this.list_logs.execute()
          }}>
          <div className='default-card' style={{ padding: 0 }}>
            <Table
              scroll={{ x: true }}
              // rowClassName='hand-cursor'
              className='main-table '
              loading={list_logs_resp.fetching}
              size='small'
              bordered={false}
              rowClassName={(record) => `${record.type}-ROW`}
              pagination={{
                position: 'bottom',
                onChange: (current, size) => {
                  this.props.history.push({
                    // pathname:"users",
                    search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                  })
                  // this.stateUpdater({
                  //   stateKey:'filter_query',
                  //   appendObj:{
                  //     per_page:size,
                  //     page:current
                  //   },
                  //   callback:()=>{
                  //     this.props.history.push({
                  //       // pathname:"users",
                  //       search:queryString.stringify(this.state.filter_query)
                  //     })
                  //   }
                  // })
                  // this.list_logs.config({
                  //   params: {
                  //     per_page: size,
                  //     page: current
                  //   }
                  // }).execute();
                },
                defaultCurrent: 1,
                current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                // defaultPageSize: 20,
                pageSize: (rowsMeta && rowsMeta.requested_count),

                total: (rowsMeta && rowsMeta.total_count > 10000 ? 10000 : rowsMeta.total_count),
                showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${rowsMeta.total_count > 10000 ? `10,000+` : formatMoney(rowsMeta.total_count,0)} items`
              }}
              // bordered={false}
              rowKey={(record) => record.id}
              expandedRowRender={(record) => {
                return <div>
                  <p className={`log-text ${record.type}-ROW`}>
                    {record.message}
                  </p>
                </div>
              }}
              columns={[
                { title: "Created At", dataIndex: 'created_at', key: 'created_at', width: 130 },
                {
                  title: "User", key: 'user_id',
                  width: 100,
                  render: (text, record) =>
                    <Link to={`/settings/users/${record.user_id}`}>{record.__references__.user_id && record.__references__.user_id.username}</Link>
                },
                { title: "Type", dataIndex: 'type', key: 'type', width: 100 },
                { title: 'IP Address', dataIndex: 'ip_address', key: 'ip_address', width: 100 },
                { title: 'Entity', dataIndex: 'entity', key: 'entity' },
                { title: "URL", dataIndex: 'url', key: 'url', className: 'word-break' }
                // { title: "Description", dataIndex: 'message', key: 'message',className:'log-text' }
              ]}
              dataSource={rowsData}
            />
          </div>
        </ErrorWrapper>
      </div>
    );
  }

  componentDidMount() {
    // this.list_logs.execute();
    overrideHeaderTitle("User Logs");
    overrideHeaderBack(null)
    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      new_filter_query = parsed;
    }
    this.setState({
      filter_query: {
        per_page: 100,
        page: 1,
        ...new_filter_query
      }
    }, () => {
      this.list_logs.config({
        params: {
          ...this.getParams()
        }
      }).execute()
    })
  }


  componentWillReceiveProps(nextProps) {

    let new_filter_query = {};
    if (nextProps.location && nextProps.location.search && (this.props.location.search !== nextProps.location.search)) {
      const parsed = queryString.parse(nextProps.location.search);
      new_filter_query = parsed;
      this.setState({
        filter_query: {
          per_page: 100,
          page: 1,
          ...new_filter_query
        }
      }, () => {
        this.list_logs.config({
          params: {
            ...this.getParams()
          }
        }).execute()
      })
    } else {
      // this.list_logs.execute()
    }


  }



}


export default withDomains(UserLogs, "logs");
